import React from 'react'
import moment from 'moment'
import Swal from 'sweetalert2'
import axios from 'axios'
import Constant, { getHourSlots } from '../../Constant.js'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import Select from 'react-select'
import GroupCheckbox from '../../common/GroupCheckbox/GroupCheckbox.js'

class BulkCouponForm extends React.Component {
  state = {
    coupon_type: 'discount', //drink
    no_of_drinks: '',

    coupon_name: '',
    note: '',
    coupon_code: '',
    amount_type: 'DECIMAL',
    amount: '',
    minimum_booking_amount: '',
    no_of_redeem: '',
    no_of_coupons: '',
    user_allow_to_use: 'MULTIPLE',
    start_date: '',
    end_date: '',
    creation_start_date: '',
    creation_end_date: '',
    start_time: '',
    end_time: '',
    is_active: true,
    products: [],
    isSaving: false,

    cruise_coupon_category: '',

    newUsersOnly: false,
    multiple: true,

    categoriesList: [],
    selected_categories: [],
    storeList: [],
    chaletList: [],
    allProductsList: [],
    categories: [],
    tripList: [],
  }

  componentDidUpdate(prevProps) {
    if (prevProps.editCouponId != this.props.editCouponId && this.props.editCouponId) {
      this.setState(
        {
          coupon_type: this.props.editCouponData.coupon_type,
          no_of_drinks: this.props.editCouponData.no_of_drinks,

          amount: this.props.editCouponData.amount,
          amount_type: this.props.editCouponData.amount_type,
          coupon_code: this.props.editCouponData.coupon_code,
          coupon_name: this.props.editCouponData.coupon_name,
          no_of_redeem: this.props.editCouponData.no_of_redeem,
          user_allow_to_use: this.props.editCouponData.user_allow_to_use,
          start_date: this.props.editCouponData.start_date,
          end_date: this.props.editCouponData.end_date,
          start_time: this.props.editCouponData.start_time,
          end_time: this.props.editCouponData.end_time,
          note: this.props.editCouponData.note,
          creation_start_date: this.props.editCouponData.creation_start_date,
          creation_end_date: this.props.editCouponData.creation_end_date,
          minimum_booking_amount: this.props.editCouponData.minimum_booking_amount,
          cruise_coupon_category: this.props.editCouponData.cruise_coupon_category,
          products: JSON.parse(this.props.editCouponData.products),

          multiple: false,
          newUsersOnly: false,
        },
        () => {
          if (this.props.editCouponData?.categories) {
            this.handleSelectCategory(this.props.editCouponData?.categories)
          }
        }
      )
    }

    if (prevProps.categoryList.length != this.props.categoryList.length) {
      this.setState({
        categoriesList: [
          {
            label: 'Store',
            value: 'Store',
          },
          {
            label: 'Chalet',
            value: 'Chalet',
          },
          {
            label: 'Cruise Trip',
            value: 'Cruise Trip',
          },
          ...this.props.categoryList.map(
            (item) =>
              item.is_active == true && {
                label: item.cruise_cat_en,
                value: item.id,
              }
          ),
        ],
      })
    }

    if (Object.keys(prevProps.list).length != Object.keys(this.props.list).length) {
      this.handleSelectCategory(this.state.selected_categories)
    }
  }

  async componentDidMount() {
    let list = await axios.get(Constant.getAPI() + '/store/stores-list', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })

    if (list.status == 200 && list.data && list.data.data && list.data.data.length > 0) {
      this.setState({
        storeList: list.data.data,
      })
    }

    let chalet_list = await axios.get(Constant.getAPI() + '/chalet/list-chalet', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })

    if (chalet_list.status == 200 && chalet_list.data && chalet_list.data.data && chalet_list.data.data.length > 0) {
      this.setState({
        chaletList: chalet_list.data.data
          .filter((item) => item.is_active)
          .map((itm) => ({
            id: itm.id,
            name: itm.name_en + ' / ' + itm.name_ar,
          })),
      })
    }

    let trip_list = await axios.get(Constant.getAPI() + '/trips/get-all-cruise-trips', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })

    if (trip_list.status == 200 && trip_list.data && trip_list.data.data && trip_list.data.data.length > 0) {
      this.setState({
        tripList: trip_list.data.data
          .filter((item) => item.is_active)
          .map((itm) => ({
            id: itm.id,
            name: itm.name_en + ' / ' + itm.name_ar,
          }))
      })
    }
  }

  handleChange = async (event) => {
    event.persist()

    if (
      event.target.name === 'amount' &&
      parseInt(event.target.value) > 100 &&
      this.state.amount_type == 'PERCENTAGE'
    ) {
      Swal.fire({
        title: 'Percentage Amount exceeded',
        icon: 'error',
        text: 'Percentage will be 1 - 100',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })

      return
    } else if (event.target.name === 'amount_type' && event.target.value != this.state.amount_type) {
      this.setState({
        amount: '',
      })
    }

    if (event.target.name === 'start_date' && this.state.end_date != '') {
      if (moment(event.target.value).valueOf() > moment(this.state.end_date).valueOf()) {
        this.setState({
          end_date: '',
        })
      }
    }
    if (event.target.name === 'creation_start_date' && this.state.creation_end_date != '') {
      if (moment(event.target.value).valueOf() > moment(this.state.creation_end_date).valueOf()) {
        this.setState({
          creation_end_date: '',
        })
      }
    }

    if (
      (event.target.name === 'no_of_redeem' ||
        event.target.name === 'no_of_coupons' ||
        event.target.name === 'amount') &&
      (event.target.value < 0 || event.target.value == '-' || event.target.value == '-0')
    ) {
      return
    }

    this.setState({ [event.target.name]: event.target.value })
  }

  onSaveData = () => {
    if (
      this.state.coupon_type == 'discount' &&
      this.state.amount_type === 'PERCENTAGE' &&
      parseInt(this.state.amount) >= 101
    ) {
      Swal.fire({
        title: 'Percentage Amount exceeded',
        icon: 'error',
        text: 'Percentage will be 1 - 100',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    this.addCoupon()
  }

  resetForm = () => {
    this.setState({
      coupon_type: 'discount', //drink
      no_of_drinks: '',

      coupon_name: '',
      coupon_code: '',
      amount_type: 'DECIMAL',
      amount: '',
      no_of_redeem: '',
      no_of_coupons: '',
      user_allow_to_use: 'MULTIPLE',
      start_date: '',
      end_date: '',
      start_time: '',
      end_time: '',
      is_active: true,
      products: [],
      isSaving: false,

      cruise_coupon_category: '',
      minimum_booking_amount: '',
      creation_start_date: '',
      creation_end_date: '',

      multiple: true,
      newUsersOnly: false,

      selected_categories: [],
      categories: [],
    })

    if (typeof this.props.reloadList == 'function') {
      this.props.reloadList()
    }
  }

  addCoupon = () => {
    this.setState({ isSaving: true })

    var data = {
      coupon_type: this.state.coupon_type,
      no_of_redeem: this.state.no_of_redeem,
      user_allow_to_use: this.state.user_allow_to_use,
      start_date: moment(this.state.start_date).format('MM/DD/YYYY'),
      end_date: moment(this.state.end_date).format('MM/DD/YYYY'),
      creation_start_date: moment(this.state.creation_start_date).format('MM/DD/YYYY'),
      creation_end_date: moment(this.state.creation_end_date).format('MM/DD/YYYY'),
      note: this.state.note,
      start_time: this.state.start_time,
      end_time: this.state.end_time,
      is_active: this.state.is_active,
      cruise_coupon_category: this.state.cruise_coupon_category,
      products: this.state.products.length == 1 && this.state.products[0] == '' ? [] : this.state.products,
      categories: this.state.categories,
    }

    if (this.state.coupon_type == 'discount') {
      data.amount_type = this.state.amount_type
      data.amount = this.state.amount
      data.minimum_booking_amount = this.state.minimum_booking_amount
    } else {
      data.no_of_drinks = this.state.no_of_drinks
    }

    if (this.props.editCouponId) {
      // data.coupon_name = this.state.coupon_code
      // data.coupon_code = this.state.coupon_code
      data.id = this.props.editCouponId

      axios
        .post(Constant.getAPI() + '/admin/edit-bulk-coupon', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isSaving: false })

          if (res.status) {
            Swal.fire({
              title: 'Coupon Edited Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }

          this.resetForm()
        })
        .catch((err) => {
          this.setState({ isSaving: false })

          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      if (this.state.multiple) {
        data.coupon_name = this.state.coupon_name
        data.no_of_coupons = this.state.no_of_coupons
      } else {
        data.coupon_name = this.state.coupon_code
        data.coupon_code = this.state.coupon_code
        data.no_of_coupons = 1
      }

      if (this.state.newUsersOnly == true) {
        data.newUsersOnly = true
      }

      axios
        .post(Constant.getAPI() + '/admin/add-bulk-coupon', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isSaving: false })

          if (res.status) {
            Swal.fire({
              title: 'Coupon Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }

          this.resetForm()
        })
        .catch((err) => {
          this.setState({ isSaving: false })

          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  clearCouponDetails = () => {
    this.setState(
      {
        coupon_type: 'discount', //drink
        no_of_drinks: '',

        coupon_name: '',
        coupon_code: '',
        amount_type: 'DECIMAL',
        amount: '',
        no_of_redeem: '',
        no_of_coupons: '',
        user_allow_to_use: 'MULTIPLE',
        start_date: '',
        end_date: '',
        start_time: '',
        end_time: '',
        creation_start_date: '',
        creation_end_date: '',
        note: '',
        is_active: true,
        products: [],
        isSaving: false,

        cruise_coupon_category: '',

        multiple: true,
        newUsersOnly: false,

        selected_categories: [],
      },
      () => {
        this.props.clearEdit()
      }
    )
  }

  handleSelectCategory = (event) => {
    this.setState(
      {
        selected_categories: event || [],
      },
      () => {
        let tempProducts = []
        const tempCategories = []

        this.state?.selected_categories?.forEach(({ value, label }) => {
          if (value == 'Chalet') {
            tempProducts = [
              ...tempProducts,
              ...this.state.chaletList.map((item) => ({
                id: item.id,
                name: item.name + '(Chalet)',
              })),
            ]
          } else if (value == 'Store') {
            tempProducts = [
              ...tempProducts,
              ...this.state.storeList.map((item) => ({
                id: item.id,
                name: (item.company_name || item.company_short_name) + '(Store)',
              })),
            ]
          } else if (value == 'Cruise Trip') {
            tempProducts = [
              ...tempProducts,
              ...this.state.tripList.map((item) => ({
                id: item.id,
                name: item.name + '(Cruise Trip)',
              })),
            ]
          }

          if (this.props.list[value] && this.props.list[value].length > 0) {
            tempProducts = [
              ...tempProducts,
              ...this.props.list[value].map((item) => ({
                id: item.id,
                name:
                  (item.cruise_name_en ? item.cruise_name_en : item.company_name || item.company_short_name) +
                  `(${label})`,
              })),
            ]
          }

          tempCategories.push({ label, value })
        })
        this.setState({
          allProductsList: tempProducts,
          products: tempProducts?.filter((i) => this.state?.products?.includes(i?.id))?.map((i) => i.id),
          categories: tempCategories,
        })
      }
    )
  }

  render() {
    return (
      <div className="card-body" style={{ background: '#f8f9fa' }}>
        {/* Header Section */}
        <div className="row mb-4">
          <div className="col-12">
            {!this.props.editCouponId ? (
              <div className="d-flex justify-content-between align-items-center p-3" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', borderRadius: '8px', color: 'white' }}>
                <div>
                  <h4 className="mb-1" style={{ color: 'white' }}>
                    <i className="icofont icofont-plus-circle mr-2"></i>
                    Create New Bulk Coupon
                  </h4>
                  <small>Fill in the details below to create coupon(s)</small>
                </div>
                <div className="d-flex align-items-center">
                  <span className="mr-3" style={{ fontSize: '14px', fontWeight: 'bold' }}>Create Multiple Coupons</span>
                  <Toggle
                    id={'coupon-type'}
                    checked={this.state.multiple}
                    icons={null}
                    onChange={() => {
                      this.setState({ multiple: !this.state.multiple })
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className="d-flex align-items-center p-3" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', borderRadius: '8px', color: 'white' }}>
                <i className="icofont icofont-edit mr-2" style={{ fontSize: '24px' }}></i>
                <h4 className="mb-0" style={{ color: 'white' }}>Edit Coupon</h4>
              </div>
            )}
          </div>
        </div>
        {/* Basic Information Section */}
        <div className="card mb-4" style={{ border: 'none', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', borderRadius: '8px' }}>
          <div className="card-body">
            <div className="row">
              {!this.props.editCouponId ? (
                this.state.multiple ? (
                  <>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label><i className="icofont icofont-tag mr-1"></i>Coupon Name <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter coupon name"
                          value={this.state.coupon_name}
                          name="coupon_name"
                          onChange={this.handleChange}
                          style={{ borderRadius: '6px' }}
                        />
                        <small className="text-muted">Prefix for generated codes</small>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label><i className="icofont icofont-numbered mr-1"></i>Number of Coupons <span className="text-danger">*</span></label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="How many?"
                          value={this.state.no_of_coupons}
                          name="no_of_coupons"
                          onChange={this.handleChange}
                          style={{ borderRadius: '6px' }}
                        />
                        <small className="text-muted">Auto-generate unique codes</small>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="col-md-4">
                    <div className="form-group">
                      <label><i className="icofont icofont-barcode mr-1"></i>Coupon Code <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter unique code"
                        value={this.state.coupon_code}
                        name="coupon_code"
                        onChange={this.handleChange}
                        style={{ borderRadius: '6px', textTransform: 'uppercase' }}
                      />
                      <small className="text-muted">Code for checkout</small>
                    </div>
                  </div>
                )
              ) : (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label><i className="icofont icofont-tag mr-1"></i>Coupon Name</label>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        value={this.state.coupon_name}
                        style={{ borderRadius: '6px', background: '#f5f5f5' }}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label><i className="icofont icofont-barcode mr-1"></i>Coupon Code</label>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        value={this.state.coupon_code}
                        style={{ borderRadius: '6px', background: '#f5f5f5' }}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className={this.state.multiple || this.props.editCouponId ? "col-md-3" : "col-md-4"}>
                <div className="form-group">
                  <label><i className="icofont icofont-refresh mr-1"></i>Maximum Redemptions <span className="text-danger">*</span></label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Total uses"
                    value={this.state.no_of_redeem}
                    name="no_of_redeem"
                    onChange={this.handleChange}
                    style={{ borderRadius: '6px' }}
                  />
                  <small className="text-muted">Total redemption limit</small>
                </div>
              </div>
              <div className={this.state.multiple || this.props.editCouponId ? "col-md-3" : "col-md-4"}>
                <div className="form-group">
                  <label><i className="icofont icofont-users mr-1"></i>Usage Restriction <span className="text-danger">*</span></label>
                  <select
                    name="user_allow_to_use"
                    className="form-control"
                    value={this.state.user_allow_to_use}
                    onChange={this.handleChange}
                    style={{ borderRadius: '6px' }}
                  >
                    <option value="MULTIPLE">Multiple Uses</option>
                    <option value="ONETIME">One Time Only</option>
                  </select>
                  <small className="text-muted">Per user limit</small>
                </div>
              </div>
            </div>

            {/* Separator */}
            <hr style={{ margin: '10px 0', border: 'none', borderTop: '2px solid #e9ecef' }} />

            {/* Creation Period */}
            <div className="row">
              <div className="col-12 mb-2">
                <h6 className="text-primary">
                  <i className="icofont icofont-ui-add mr-1"></i>
                  Creation Period
                  <small className="text-muted ml-2">(When can this coupon be created/used for the first time?)</small>
                </h6>
              </div>
              <div className="col-3">
                <div className="form-group">
                  <label><i className="icofont icofont-clock-time mr-1"></i>Start Date <span className="text-danger">*</span></label>
                  <input
                    type="date"
                    min={moment().format('YYYY-MM-DD')}
                    id="creation_start_date"
                    className="form-control"
                    value={this.state.creation_start_date}
                    name="creation_start_date"
                    onChange={this.handleChange}
                    style={{ borderRadius: '6px' }}
                  />
                  <small className="text-muted">Coupon becomes available from this date</small>
                </div>
              </div>
              <div className="col-3">
                <div className="form-group">
                  <label><i className="icofont icofont-clock-time mr-1"></i>End Date <span className="text-danger">*</span></label>
                  <input
                    type="date"
                    id="creation_end_date"
                    min={
                      this.state.creation_start_date
                        ? moment(this.state.creation_start_date).format('YYYY-MM-DD')
                        : moment().format('YYYY-MM-DD')
                    }
                    className="form-control"
                    value={this.state.creation_end_date}
                    name="creation_end_date"
                    onChange={this.handleChange}
                    style={{ borderRadius: '6px' }}
                  />
                  <small className="text-muted">Coupon expires on this date</small>
                </div>
              </div>
            </div>
            
            {/* Separator */}
            <hr style={{ margin: '10px 0', border: 'none', borderTop: '2px solid #e9ecef' }} />

            {/* Booking Period */}
            <div className="row mt-3">
              <div className="col-12 mb-3">
                <h6 className="text-success">
                  <i className="icofont icofont-ticket mr-1"></i>
                  Booking Period
                  <small className="text-muted ml-2">(For which booking dates is this coupon valid?)</small>
                </h6>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label><i className="icofont icofont-calendar mr-1"></i>Start Date <span className="text-danger">*</span></label>
                  <input
                    type="date"
                    min={moment().format('YYYY-MM-DD')}
                    id="start_date"
                    className="form-control"
                    value={this.state.start_date}
                    name="start_date"
                    onChange={this.handleChange}
                    style={{ borderRadius: '6px' }}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label><i className="icofont icofont-calendar mr-1"></i>End Date <span className="text-danger">*</span></label>
                  <input
                    type="date"
                    id="end_date"
                    min={
                      this.state.start_date
                        ? moment(this.state.start_date).format('YYYY-MM-DD')
                        : moment().format('YYYY-MM-DD')
                    }
                    className="form-control"
                    value={this.state.end_date}
                    name="end_date"
                    onChange={this.handleChange}
                    style={{ borderRadius: '6px' }}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label><i className="icofont icofont-ui-clock mr-1"></i>Start Time <span className="text-danger">*</span></label>
                  <select
                    name="start_time"
                    className="form-control"
                    value={this.state.start_time}
                    onChange={this.handleChange}
                    style={{ borderRadius: '6px' }}
                  >
                    <option value="">Select time</option>
                    {getHourSlots().map((itm) => (
                      <option value={itm.value} key={itm.value}>
                        {itm.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label><i className="icofont icofont-ui-clock mr-1"></i>End Time <span className="text-danger">*</span></label>
                  <select
                    name="end_time"
                    className="form-control"
                    value={this.state.end_time}
                    onChange={this.handleChange}
                    style={{ borderRadius: '6px' }}
                  >
                    <option value="">Select time</option>
                    {getHourSlots().map((itm) => (
                      <option value={itm.value} key={itm.value}>
                        {itm.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            
            {/* Separator */}
            <hr style={{ margin: '10px 0', border: 'none', borderTop: '2px solid #e9ecef' }} />

            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label><i className="icofont icofont-clip mr-1"></i>Apply Discount On</label>
                  <select
                    name="cruise_coupon_category"
                    className="form-control"
                    value={this.state.cruise_coupon_category}
                    onChange={this.handleChange}
                    style={{ borderRadius: '6px' }}
                  >
                    <option value="">All Services</option>
                    <option value="cruise">🚢 Cruise</option>
                    <option value="chalet">🏠 Chalet</option>
                    <option value="addon">➕ Add Ons</option>
                    <option value="store">🛒 Store</option>
                    <option value="catering">🍽️ Catering</option>
                    <option value="cruise_trip">⛴️ Cruise Trip</option>
                  </select>
                  <small className="text-muted">Select which service type this applies to</small>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label><i className="icofont icofont-listine-dots mr-1"></i>Select Categories</label>
                  <Select
                    name="categories"
                    value={this.state.selected_categories}
                    onChange={this.handleSelectCategory}
                    options={this.state.categoriesList}
                    isMulti={true}
                    isSearchable={true}
                    placeholder="All categories or select specific..."
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: '6px',
                        minHeight: '38px'
                      })
                    }}
                  />
                  <small className="text-muted">Leave empty for all categories</small>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label><i className="icofont icofont-comment mr-1"></i>Description (Optional)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g., Summer promotion for cruises"
                    value={this.state.note}
                    name="note"
                    onChange={this.handleChange}
                    style={{ borderRadius: '6px' }}
                  />
                  <small className="text-muted">Internal note for reference</small>
                </div>
              </div>
            </div>
            
            {/* Product Selection */}
            {this.state.selected_categories.length > 0 && (
              <div className="row mt-4">
                <div className="col-12">
                  <div className="alert alert-info" style={{ borderRadius: '6px', borderLeft: '4px solid #17a2b8' }}>
                    <i className="icofont icofont-info-circle mr-2"></i>
                    <strong>Product Selection:</strong> Choose specific products or leave all unchecked to apply coupon to all products in selected categories.
                  </div>
                  <GroupCheckbox
                    title={'📦 Specific Products (Optional)'}
                    list={this.state.allProductsList}
                    displayKey={'name'}
                    idKey={'id'}
                    selected={this.state.products}
                    onChange={(event) => {
                      this.setState({ products: event })
                    }}
                  />
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-3 mb-3">
                <label><i className="icofont icofont-ui-switch mr-1"></i>Coupon Type <span className="text-danger">*</span></label>
                <div className="btn-group btn-group-toggle w-100" data-toggle="buttons">
                  <label 
                    className={`btn ${this.state.coupon_type === 'discount' ? 'btn-primary' : 'btn-outline-primary'}`}
                    style={{ borderRadius: '6px 0 0 6px', padding: '5px' }}
                    onClick={() => this.setState({ coupon_type: 'discount' })}
                  >
                    <input type="radio" name="coupon_type" checked={this.state.coupon_type === 'discount'} readOnly />
                    <i className="icofont icofont-sale-discount mr-2"></i>
                    Discount Coupon
                  </label>
                  <label 
                    className={`btn ${this.state.coupon_type === 'drink' ? 'btn-info' : 'btn-outline-info'}`}
                    style={{ borderRadius: '0 6px 6px 0', padding: '5px' }}
                    onClick={() => this.setState({ coupon_type: 'drink' })}
                  >
                    <input type="radio" name="coupon_type" checked={this.state.coupon_type === 'drink'} readOnly />
                    <i className="icofont icofont-beer mr-2"></i>
                    Drink Voucher
                  </label>
                </div>
              </div>
              
              {this.state.coupon_type === 'drink' ? (
                <div className="col-3">
                  <div className="form-group">
                    <label><i className="icofont icofont-beer mr-1"></i>Number of Drinks <span className="text-danger">*</span></label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="How many drinks can be redeemed?"
                      value={this.state.no_of_drinks}
                      name="no_of_drinks"
                      onChange={this.handleChange}
                      style={{ borderRadius: '6px', fontSize: '16px', padding: '12px' }}
                    />
                    <small className="text-muted">Number of complimentary drinks included with this voucher</small>
                  </div>
                </div>
              ) : (
                <>
                  <div className="col-3">
                    <div className="form-group">
                      <label><i className="icofont icofont-ui-rate-blank mr-1"></i>Discount Type <span className="text-danger">*</span></label>
                      <select
                        value={this.state.amount_type}
                        name="amount_type"
                        onChange={this.handleChange}
                        className="form-control"
                        style={{ borderRadius: '6px' }}
                      >
                        <option value="DECIMAL">💰 Fixed Amount</option>
                        <option value="PERCENTAGE">% Percentage</option>
                      </select>
                      <small className="text-muted">Choose discount calculation method</small>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>
                        <i className="icofont icofont-coins mr-1"></i>
                        Discount {this.state.amount_type === 'PERCENTAGE' ? 'Percentage' : 'Amount'} <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          type="number"
                          className="form-control"
                          placeholder={this.state.amount_type === 'PERCENTAGE' ? 'e.g., 20' : 'e.g., 50'}
                          value={this.state.amount}
                          name="amount"
                          onChange={this.handleChange}
                          style={{ borderRadius: '6px 0 0 6px' }}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text" style={{ borderRadius: '0 6px 6px 0', background: '#007bff', color: 'white', fontWeight: 'bold' }}>
                            {this.state.amount_type === 'PERCENTAGE' ? '%' : ''}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label><i className="icofont icofont-cart mr-1"></i>Minimum Order Value</label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="e.g., 100 (optional)"
                        value={this.state.minimum_booking_amount}
                        name="minimum_booking_amount"
                        onChange={this.handleChange}
                        style={{ borderRadius: '6px' }}
                      />
                      <small className="text-muted">Minimum purchase required to use coupon</small>
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Action Section */}
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center" >
              {/* User Restrictions */}
              {!this.props.editCouponId && (
                <div className="d-flex justify-content-between align-items-center p-3 mb-3" style={{ background: '#f8f9fa', borderRadius: '6px', border: '2px solid #e9ecef' }}>
                  <div>
                    <strong style={{ fontSize: '16px', color: '#495057' }}>
                      <i className="icofont icofont-star mr-2" style={{ color: '#ffc107' }}></i>
                      New Users Only
                    </strong>
                    <p className="mb-0 text-muted" style={{ fontSize: '13px' }}>Restrict this coupon to users registered after coupon creation</p>
                  </div>
                  <Toggle
                    icons={null}
                    checked={this.state.newUsersOnly}
                    onChange={() => {
                      this.setState({ newUsersOnly: !this.state.newUsersOnly })
                    }}
                  />
                </div>
              )}
              
              {/* Action Buttons */}
              <div className="d-flex justify-content-end align-items-center">
                <button
                  className="btn btn-outline-secondary btn-lg mr-3"
                  onClick={this.clearCouponDetails}
                  style={{ borderRadius: '6px', minWidth: '120px' }}
                >
                  <i className="icofont icofont-refresh mr-2"></i>
                  Clear Form
                </button>
                {this.state.isSaving ? (
                  <button
                    className="btn btn-secondary btn-lg"
                    disabled
                    style={{ borderRadius: '6px', minWidth: '180px' }}
                  >
                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                    Saving...
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn btn-lg"
                    style={{ 
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      borderRadius: '6px',
                      minWidth: '180px',
                      border: 'none',
                      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
                    }}
                  >
                    <i className="icofont icofont-save mr-2"></i>
                    {this.props.editCouponId ? 'Update Coupon' : 'Create Coupon'}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BulkCouponForm
